import { render, staticRenderFns } from "./LaudoSupressaoVegetalModal.vue?vue&type=template&id=0f8ec2bb&scoped=true&lang=pug"
import script from "./LaudoSupressaoVegetalModal.vue?vue&type=script&lang=js"
export * from "./LaudoSupressaoVegetalModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoSupressaoVegetalModal.vue?vue&type=style&index=0&id=0f8ec2bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8ec2bb",
  null
  
)

export default component.exports